import axios from "axios";
import {API_URL, APP_URL} from "../config";

export const storeDoctorService = async (values) => {
    return axios.post(`${API_URL}/doctors`, {...values});
};

export const updateDoctorService = async (id, values) => {
    return axios.put(`${API_URL}/doctors/${id}`, {...values});
};

export const getDoctorService = async (id) => {
    return axios.get(`${API_URL}/doctors/${id}`);
}

export const listDoctorsService = async (params) => {
    return axios.get(`${API_URL}/doctors`, {
        params: {
            ...params
        }
    });
}
